import { ReactNode, useEffect } from "react";
import { BsXLg, BsJustifyLeft } from 'react-icons/bs';
import classes from './style.module.scss';
type TModalHeaderProps = {
    title: string
}
export const ModalHeader = ({ title }: TModalHeaderProps) => {
    return (
        <div className={`no-bt-margin ${classes.modalHeader}`}>
            <BsJustifyLeft style={{ fontSize: '1.3rem' }} />
            <span className={classes.title}>{title}</span>
        </div>
    )
}
type Iprops = {
    children: ReactNode,
    open?: boolean,
    title?: string,
    onClose?: () => void
    size?: {
        height?: string,
        width?: string,
    },
    className?: string
}
const Modal = ({ children, open = false, onClose, title = '', className = '', size }: Iprops) => {
    let style: any = {};
    if (size && size.width) {
        style.width = size.width;
    }
return (
    <>
        <div className={open ? `${classes.modalContainer} ${classes.open} overflow-auto` : `${classes.modalContainer} overflow-auto`}>
            <div className={`${classes.modal} ${className} flex flex-col overflow-auto`} style={{ maxHeight: '80vh', ...style }}  >
                <BsXLg className={"icon-button " + classes.closebtn} onClick={() => { typeof onClose === 'function' && onClose() }} />
                {title && <ModalHeader title={title} />}
                {children}
            </div>
        </div>
    </>
)
}
export default Modal;